// can-deactivate.guard.ts
import { Injectable } from '@angular/core';
import { CanDeactivate, NavigationEnd, Router } from '@angular/router';
import { NgxToastrService, TrainService } from '@core/services';
import { TranslateService } from '@ngx-translate/core';
import { filter, pairwise, startWith } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ClearBookingGuard implements CanDeactivate<unknown> {
  previousUrl: string = '';
  currentUrl: string = '';

  constructor(
    private router: Router,
    private ngxToastrService: NgxToastrService,
    private translate: TranslateService,
    private trainService: TrainService
  ) {}
  canDeactivate(): boolean {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        startWith(
          new NavigationEnd(
            0,
            this.router.url,
            this.router.url
          )
        ),
        pairwise()
      )
      .subscribe(([prev, current]) => {
        this.previousUrl = prev.urlAfterRedirects;
        this.currentUrl = current.urlAfterRedirects;
        if (localStorage.getItem('isPackageRate') && localStorage.getItem('isPackageRate') === 'accommodation' && this.previousUrl.includes('search') && !this.currentUrl.includes('search') && !this.currentUrl.includes('flight')) {
          this.translate
            .get("common.out-package")
            .subscribe((result) => {
              localStorage.removeItem('packageRateAccomInfo');
              localStorage.removeItem('isPackageRate')
              this.ngxToastrService.typeInfo(result, '');
            });
        } else if (localStorage.getItem('isPackageRate') && localStorage.getItem('isPackageRate') === 'flight' && this.previousUrl.includes('flight') && !this.currentUrl.includes('flight') && !this.currentUrl.includes('search')) {
          this.translate
            .get("common.out-package")
            .subscribe((result) => {
              localStorage.removeItem('packageRateFlightInfo');
              localStorage.removeItem('isPackageRate')
              this.ngxToastrService.typeInfo(result, '');
            });
        } else if (localStorage.getItem('isPackageRate') && (!localStorage.getItem('packageRateFlightInfo') || !localStorage.getItem('packageRateAccomInfo')) && ((this.previousUrl.includes('flight') && !this.currentUrl.includes('flight') && !this.currentUrl.includes('search')) || (this.previousUrl.includes('search') && !this.currentUrl.includes('search') && !this.currentUrl.includes('flight')))) {
          this.translate
            .get("common.out-package")
            .subscribe((result) => {
              localStorage.removeItem('isPackageRate')
              localStorage.removeItem('packageRateFlightInfo');
              localStorage.removeItem('packageRateAccomInfo');
              this.ngxToastrService.typeInfo(result, '');
            });
        } else if (this.previousUrl.includes('train') && !this.currentUrl.includes('train')) {
          this.trainService.clearTrainsInfo()
          this.trainService.setTrainsInfoPartial({
            searchConfig: {
              departDate: null,
              returnDate: null,
              travellers: [],
              origin: null,
              destination: null,
              oneWay: false,
              project: null
            }
          })
        }
      })
    return true;
  }
}
